import { render } from "./ReviewListParts.vue?vue&type=template&id=6af7663c"
import script from "./ReviewListParts.vue?vue&type=script&lang=js"
export * from "./ReviewListParts.vue?vue&type=script&lang=js"

import "./ReviewListParts.vue?vue&type=style&index=0&id=6af7663c&lang=scss"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__